module.exports = __webpack_public_path__ + "media/images/worker-07ef9c26aeb9a9391af681b7886c110e.png";